const testimonialsSwiper = new Swiper(".testimonials_swiper", {
  autoplay: {
    delay: 2750,
    disableOnInteraction: true,
  },
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

const scrollTargetElements = document.querySelectorAll("*[data-scroll-target]");

scrollTargetElements.forEach((element) => {
  element.addEventListener("click", (e) => {
    const targetElementId =
      element.attributes.getNamedItem("data-scroll-target").value;
    const targetElement = document.querySelector(`#${targetElementId}`);
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  });
});
